import React from 'react';
import { Button, Grid, Typography, useTheme, Box } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import CloseIcon from '@mui/icons-material/Close';
import { currency } from '@shared/hooks/currencies';

import { sxStyled } from './styles';

const ModalChangedPNR = ({
  closeModal,
  state,
  isInUSD,
  handleCancel,
  handleConfirm,
}) => {
  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  const total = state.PNR.prices_changed?.total;
  const priceTo = total?.to;
  const priceDiff = total?.diff;

  return (
    <Box>
      <Grid container direction="column" spacing={2} sx={sxStyle.root}>
        {/* Close */}
        <Grid item xs={12} sx={sxStyle.closeIconContainer}>
          <CloseIcon
            onClick={closeModal}
            fontSize="medium"
            sx={{ cursor: 'pointer' }}
          />
        </Grid>

        {/* Icon */}
        <Grid item xs={12} container justifyContent="center">
          <WarningIcon
            sx={{
              pt: 4,
              width: 100,
              height: 100,
              color: 'yellow',
            }}
          />
        </Grid>

        {/* Text */}
        <Grid item xs={12}>
          <Typography variant="h6" align="left" sx={sxStyle.firstText}>
            Tu reserva fue confirmada, pero se aplicó un ajuste en el precio.
          </Typography>

          <Typography variant="h6" align="left" sx={sxStyle.secondaryText}>
            La diferencia final es de {currency(priceDiff, isInUSD)} respecto al
            monto original
          </Typography>

          <Typography
            variant="h6"
            align="left"
            sx={{ ...sxStyle.secondaryText, mb: 2 }}
          >
            Monto final: {currency(priceTo, isInUSD)}
          </Typography>
        </Grid>

        {/* Actions */}
        <Grid item xs={12}>
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12} sm="auto">
              <Button
                fullWidth
                sx={sxStyle.continueButton}
                onClick={handleConfirm}
              >
                Continuar
              </Button>
            </Grid>

            <Grid item xs={12} sm="auto">
              <Button
                fullWidth
                variant="contained"
                sx={sxStyle.addButton}
                onClick={() => handleCancel(state.PNR.PNR_code)}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ModalChangedPNR;
